import { IDmLoaiThuNhapHocRequest } from "../../model/request/category/dmLoaiThuNhapHocRequest";
import { IDmLoaiThuNhapHoc } from "../../model/respone/category/IDmLoaiThuNhapHoc";
import { apiClient } from "../apiClient";
export const LOAI_THU_NHAP_HOC_ENDPOINT = "loai-thu-nhap-hoc";
export const loaiThuNhapHocApi = {
  SelectViewModelAll: () => apiClient.get(`${LOAI_THU_NHAP_HOC_ENDPOINT}`),
  Insert: (payload: IDmLoaiThuNhapHoc) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}`, payload),
  Update: (payload: IDmLoaiThuNhapHoc) =>
    apiClient.put(`${LOAI_THU_NHAP_HOC_ENDPOINT}`, payload),
  Delete: (id: number) =>
    apiClient.delete(`${LOAI_THU_NHAP_HOC_ENDPOINT}/${id}`),
  DeleteMany: (ids: number[]) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/delete-many`, ids),
  SelectHeNganhsByDot: (payload: IDmLoaiThuNhapHocRequest) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/select-he-nganhs`, payload),
  InsertMultiple: (payload: IDmLoaiThuNhapHoc[]) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/insert-multiple`, payload),
  SelectByDot: (payload: IDmLoaiThuNhapHocRequest) =>
    apiClient.post(`${LOAI_THU_NHAP_HOC_ENDPOINT}/select-by-dot`, payload),
};
